// import { DateFormatter } from '@fullcalendar/core/internal';
import { EScheduleRepeat, ScheduleRepeat } from '../model/schedule-repeat';
import { WeekDay } from '../model/week-day';

export const SCHEDULE_REPETITIONS: ScheduleRepeat[] = [
    { Value: EScheduleRepeat.Days, Name: 'DAILY' },
    { Value: EScheduleRepeat.Weeks, Name: 'WEEKLY' },
    { Value: EScheduleRepeat.Months, Name: 'MONTHLY' },
    { Value: EScheduleRepeat.NotRepeat, Name: 'NOT_REPEATING' }
];

export const WEEK_DAYS: WeekDay[] = [
    { Value: '0', Name: 'SUN' },
    { Value: '1', Name: 'MON' },
    { Value: '2', Name: 'TUE' },
    { Value: '3', Name: 'WED' },
    { Value: '4', Name: 'THU' },
    { Value: '5', Name: 'FRI' },
    { Value: '6', Name: 'SAT' }
];

// export const CALENDAR_EVENT_TIME_FORMAT = { hour: '2-digit', minute: '2-digit', meridiem: false };
export const CALENDAR_HEADER_TOOLBAR = { left: 'prev,next,today', center: 'title', right: 'dayGridMonth,dayGridWeek' };

export const MAX_SCHEDULE_ON_CALENDAR_PAGE = 50;
export const SCHEDULE_START_DAYS_IN_FUTURE = 1;
export const SCHEDULE_DEFAULT_REPETITION = { Value: EScheduleRepeat.NotRepeat, Name: 'NOT_REPEATING' };
export const SCHEDULE_DEFAULT_TIMEZONE = 'Europe/Rome';
export const SCHEDULE_DEFAULT_COLOR = '#FF6900';
export const SCHEDULE_EXCEPTION_COLOR = '#767676';

export const LIST_COLOR: string[] = ["#f44336", "#e91e63", "#9c27b0", "#673ab7",
    "#3f51b5", "#2196f3", "#03a9f4", "#00bcd4", "#009688", "#4caf50", "#8bc34a",
    "#cddc39", "#ffeb3b", "#ffc107", "#ff9800", "#ff6900", "#795548", "#607d8b"
];
